<template>
  <mdb-container class="gp-has-header text-left">
    <mdb-card v-if="currentGroup">
      <mdb-card-body class="text-left">
        <group-card :group="currentGroup"/>
        <mdb-btn @click="$router.push('/admin/group/' + currentGroup.id)" icon="arrow-left" rounded size="sm">Group
          Admin
        </mdb-btn>
        <mdb-input disabled label="Current Owner Name" type="text" v-model="currentGroup.ownerName"/>
        <h5>New Owner:</h5>
        <data-table :clickHandler="pickedUser"
                    :columns="columns"
                    dataSource="/user/list"/>
      </mdb-card-body>
    </mdb-card>
    <mdb-modal v-if="userModal" @close="userModal = false" avatar size="lg">
      <mdb-modal-header :close="false">
        <img :src="user.avatar" alt="avatar" class="rounded-circle img-responsive">
      </mdb-modal-header>
      <mdb-modal-body class="mb-1">
        <mdb-card>
          <mdb-card-header class="primary-color text-white text-center">
            <h5 class="mt-1 mb-2">{{user.name}}</h5>
          </mdb-card-header>
          <mdb-card-body>
            <div class="text-left">
              <div>
                <span class="member-label">Username:</span>{{user.username}}
              </div>
              <div>
                <span class="member-label">Email:</span>{{user.email}}
              </div>
            </div>
          </mdb-card-body>
          <mdb-card-footer class="text-center">
            <mdb-btn @click="doSwitch" icon="check" rounded
                     size="sm">
              Make New Owner
            </mdb-btn>
            <mdb-btn @click="userModal = false" icon="times-circle" rounded size="sm">Close</mdb-btn>
          </mdb-card-footer>
        </mdb-card>
      </mdb-modal-body>
    </mdb-modal>


  </mdb-container>
</template>

<script>
import dataTable from '../common/DataTable'
import GroupCard from "../group/Card";
import api from "../../services/groupsPlaceApi";
//import {mapState} from 'vuex'
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalTitle
} from 'mdbvue';

export default {
  name: 'admin-group',
  components: {
    mdbBtn,
    mdbCard,
    mdbContainer,
    mdbInput,
    mdbCardBody,
    mdbCardFooter,
    mdbCardHeader,
    mdbIcon,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalTitle,
    dataTable,
    GroupCard
  },
  data() {
    return {
      currentGroup: null,
      user: null,
      userModal: false,
      columns: [
        {label: "ID", field: "id"},
        {label: "", field: "avatar", type: "avatar"},
        {label: "Name", field: "name"},
        {label: "E-Mail", field: "email"},
        {label: "Username", field: "username"},
        {label: "Created", field: "createDate"},
        {label: "Delete After", field: "deleteAfter"},
        {label: "Last Billed", field: "lastBilled"},
      ],
    }
  },
  mounted() {
    this.$store.dispatch("setExecuting", true)

    api.post("/admin/groups", { query: "id:" + this.$route.params.id, selectedFilters: [],
      sortColumn: "name", sortOrder: "asc"} ).then(
      (results) => {
        this.currentGroup = results.data.rows[0]
        this.$nextTick(function () {
          let el = document.getElementById("new-owner");
          if (el) el.focus();
        });
      },
      (error) => {
        this.$notify.error({message: error.response.data, timeOut: 20000})
      }).then(() => {
      this.$store.dispatch("setExecuting", false)
    })
  },
  methods: {
    pickedUser: function (user) {
      this.user = user
      this.userModal = true
    },
    doSwitch: function () {
      this.userModal = false
      this.$store.dispatch("setExecuting", true)
      api.post("/admin/changeOwner" , {group: this.currentGroup.id, user: this.user.id}).then(
        (results) => {
          this.$router.push("/admin/group/" + this.currentGroup.id)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
};
</script>
